import { DarwinFlex } from 'components/darwin-ui';
import DarwinTypography from 'components/darwin-ui/Typography';
import styles from './index.module.css';

interface WizardSectionProps {
  title: string;
  description: string;
  children: React.ReactNode;
}

export const WizardSection = ({
  title,
  description,
  children,
}: WizardSectionProps) => {
  return (
    <DarwinFlex className={styles.wizardSection} vertical>
      <DarwinFlex className={styles.wizardSectionHeader} vertical>
        <DarwinTypography.Title level={3} className={styles.noMargin}>
          {title}
        </DarwinTypography.Title>
        <DarwinTypography.Text className={styles.noMargin}>
          {description}
        </DarwinTypography.Text>
      </DarwinFlex>
      {children}
    </DarwinFlex>
  );
};
